import campaigns from '@/campaigns/store'
import dashboard from '@/dashboard/store'
import monsterleads from '@/monsterleads/store'
import notifications from '@/notifications/store'
import omu from '@/university/store'
import plugins from '@/store/modules/plugins'
import settings from '@/settings/store'
import tabs from '@/store/modules/tabs'
import templates from '@/templates/store'
import wizard from '@/wizard/store'
import wp from '@/store/modules/wordpress'

export default {
	campaigns,
	dashboard,
	monsterleads,
	notifications,
	omu,
	plugins,
	settings,
	tabs,
	templates,
	wizard,
	wp,
}
